var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarBundles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14448 8.05573C11.1026 8.05573 14.2034 6.36433 14.2034 4.20541C14.2034 2.0465 11.1026 0.269531 7.14448 0.269531C3.18635 0.269531 0 2.0465 0 4.20541C0 6.36433 3.18635 8.05573 7.14448 8.05573Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.7109V15.7566C0 17.9155 3.18635 19.6069 7.14448 19.6069C7.369 19.6069 7.58654 19.5862 7.80759 19.5754C7.31535 18.8014 6.94824 17.9426 6.73207 17.0246C3.86979 16.9455 1.38449 16.066 0 14.7109Z",
    fill: "#8D8BD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53361 15.7226C6.51889 15.5208 6.50276 15.3192 6.50276 15.1136C6.50276 14.4446 6.59042 13.7972 6.7399 13.1733C3.87406 13.0957 1.38573 12.2157 0 10.8594V11.905C0 13.9494 2.87756 15.556 6.53361 15.7226Z",
    fill: "#FCA23F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14448 11.9116C7.14517 11.9116 7.14572 11.9115 7.14645 11.9115C7.56969 10.9 8.18493 9.98812 8.94896 9.22413C8.3694 9.29737 7.77046 9.34468 7.14448 9.34468C4.09772 9.34468 1.4514 8.43614 0 7.01562V8.06124C0 10.2202 3.18635 11.9116 7.14448 11.9116Z",
    fill: "#FF0000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9481,
    cy: 15.2137,
    r: 7.05748,
    fill: "#68C598"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7584 14.837C14.1503 14.837 13.6556 14.3423 13.6556 13.7343C13.6556 13.1262 14.1503 12.6316 14.7584 12.6316C15.3664 12.6316 15.8611 13.1262 15.8611 13.7343C15.8611 13.9779 16.0586 14.1754 16.3022 14.1754C16.5458 14.1754 16.7433 13.9779 16.7433 13.7343C16.7433 12.7914 16.0822 12.0006 15.1994 11.7994V11.3083C15.1994 11.0647 15.002 10.8672 14.7584 10.8672C14.5147 10.8672 14.3173 11.0647 14.3173 11.3083V11.7994C13.4345 12.0006 12.7734 12.7914 12.7734 13.7343C12.7734 14.8288 13.6639 15.7192 14.7584 15.7192C15.3664 15.7192 15.8611 16.2139 15.8611 16.8219C15.8611 17.43 15.3664 17.9247 14.7584 17.9247C14.1503 17.9247 13.6556 17.43 13.6556 16.8219C13.6556 16.5783 13.4582 16.3808 13.2145 16.3808C12.9709 16.3808 12.7734 16.5783 12.7734 16.8219C12.7734 17.7648 13.4345 18.5557 14.3173 18.7568V19.2479C14.3173 19.4915 14.5147 19.689 14.7584 19.689C15.002 19.689 15.1994 19.4915 15.1994 19.2479V18.7568C16.0822 18.5557 16.7433 17.7648 16.7433 16.8219C16.7433 15.7274 15.8528 14.837 14.7584 14.837Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBundles);
export default __webpack_public_path__ + "static/media/dollar-bundles.4f0a48f41fa62af3a0271d5ccfb379b3.svg";
export { ForwardRef as ReactComponent };